import { ServiceBase } from '../../../../core/services/ServiceBase'
import AlertSettingProxy from './AlertSettingProxy'

class AlertSettingService extends ServiceBase {
  getAlertSetting(params) {
    return this.getData(() => AlertSettingProxy.getAlertSetting(params))
  }
  getProfileDetail(params) {
    return this.getData(() => AlertSettingProxy.getProfileDetail(params))
  }
  getProfileDefault(params) {
    return this.getData(() => AlertSettingProxy.getProfileDefault(params))
  }
  updateProfileDetail(params) {
    return this.getData(
      () => AlertSettingProxy.updateProfileDetail(params),
      true,
    )
  }
  createProfile(params) {
    return this.getData(() => AlertSettingProxy.createProfile(params))
  }
}

export default new AlertSettingService()
